import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authStates } from '../../../redux/authStates';
import { useAppSelector } from '../../../redux/store/configureStore';
import { paths } from '../../../routes/paths';
import AuthFormHeader from '../components/auth-form-header';
import LoginForm from '../components/auth-login-form';
import { useMsal } from '@azure/msal-react';

export default function SignIn() {
    const navigate = useNavigate();
    const authCurrentState = useAppSelector((state) => state.user.currentState);
    const isLoadingUser = useAppSelector((state) => state.user.isLoadingData);
    const msalInstance = useMsal();
    const account = msalInstance.instance.getActiveAccount();

    useEffect(() => {
        if (isLoadingUser) {
            return;
        }

        const isUserFullyConfigured = authCurrentState === authStates.FULLY_CONFIGURED;
        const isUserNotConfigured = authCurrentState === authStates.NOT_CONFIGURED;
        const hasManyOrganizations = authCurrentState === authStates.CHOOSE_ORGANIZATION;
        const isLoggedOut = authCurrentState === authStates.LOGGED_OUT;

        if (!window.location.pathname.includes(paths.LOGIN)) {
            return;
        } else if (isLoggedOut) {
            return;
        } else if (isUserNotConfigured) {
            navigate(paths.CONFIGURE_PROFILE);
        } else if (hasManyOrganizations) {
            navigate(paths.ACCOUNTS);
        } else if (isUserFullyConfigured) {
            navigate(paths.HOME);
        }
    }, [isLoadingUser, account]);

    return (
        <Box
            sx={{
                width: '360px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '32px',
            }}
        >
            <AuthFormHeader />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                }}
            >
                <LoginForm />
            </Box>
        </Box>
    );
}
